import { GlobalEventResponse } from "features/CenterContent/RoleContent/GlobalEvents/types/responseSchema";
import { WithInternalMessages } from "features/CenterContent/RoleContent/InternalMessage/utils/withInternalMessages";
import { GlobalEventsList } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/GlobalEventsList";
import { ParseResultDisplayer } from "shared/components/dataDisplay/ParseResultDisplayer";
import { Flex } from "shared/components/Spor";
import { useParseResultContext } from "shared/utils/useParseResult";

type GlobalEventsProps = {
  data: WithInternalMessages<GlobalEventResponse>[];
  onEditClick: (event: WithInternalMessages<GlobalEventResponse>) => void;
};

export const GlobalEvents = ({ data, onEditClick }: GlobalEventsProps) => {
  const { errors } = useParseResultContext();
  return (
    <Flex flexDirection="column" gap="12px">
      <ParseResultDisplayer errors={errors("global")} />
      <GlobalEventsList data={data} onEditClick={onEditClick} />
    </Flex>
  );
};
